import { useFormContext } from 'react-hook-form'

const Honeypot = () => {
  const { register } = useFormContext()

  return (
    <input
      {...register('referral_code')}
      id="referral_code"
      type="text"
      autoComplete="invalid"
      tabIndex={-1}
      aria-hidden="true"
      aria-label="Refferal Code"
      style={{
        position: 'absolute',
        left: '-9999px',
        opacity: 0,
        height: 0,
        width: 0,
        overflow: 'hidden',
      }}
    />
  )
}

export default Honeypot
